import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  input,
  output,
  viewChild,
} from "@angular/core";

@Component({
    selector: "app-popover",
    templateUrl: "./popover.component.html",
    styleUrls: ["./popover.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoverComponent {
    readonly popoverBody = viewChild<ElementRef<HTMLElement> | undefined>("popoverBody")
    readonly isPopoverVisible = input<boolean | null>(false);
    readonly hidePopover = output<void>();

    @HostListener("document:click", ["$event"])
    clickOutside(event: MouseEvent): void {
        if (this.isPopoverVisible()) {
            const target = event.target;

            if (!(target instanceof Element)) {
                return;
            }
            event.stopPropagation();
            if (
                !this.popoverBody()?.nativeElement.contains(target)
            ) {
                this.hidePopover.emit();
            }
        }

    }
}
